import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]

import { inject, computed, ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipContent',
  props: {
    class: {},
    side: { default: 'top' },
    variant: { default: 'default' },
    offset: { default: 12 }
  },
  setup(__props: any) {

const ctx = inject<any>('tooltipCtx')
if (!ctx) console.warn('TooltipContent used outside Tooltip root')
const props = __props
const classes = computed(() => [
  'tt-content',
  props.variant === 'shad' ? 'tt-shadcn' : '',
  props.class
].filter(Boolean).join(' '))

const el = ref<HTMLElement | null>(null)
const styleObj = ref<Record<string, string>>({})

function computePosition() {
  if (!ctx?.triggerEl?.value || !el.value) return
  const t = ctx.triggerEl.value as HTMLElement
  const c = el.value as HTMLElement
  const tr = t.getBoundingClientRect()
  const cr = c.getBoundingClientRect() // dimensions only; top/left will be recalculated
  const gap = props.offset ?? 12
  let top = 0
  let left = 0
  switch (props.side) {
    case 'bottom':
      top = tr.bottom + gap
      left = tr.left + tr.width / 2 - cr.width / 2
      break
    case 'left':
      top = tr.top + tr.height / 2 - cr.height / 2
      left = tr.left - gap - cr.width
      break
    case 'right':
      top = tr.top + tr.height / 2 - cr.height / 2
      left = tr.right + gap
      break
    case 'top':
    default:
      top = tr.top - gap - cr.height
      left = tr.left + tr.width / 2 - cr.width / 2
      break
  }

  // Keep within viewport bounds (basic clamping)
  const vw = window.innerWidth
  const vh = window.innerHeight
  const padding = 4
  left = Math.max(padding, Math.min(left, vw - cr.width - padding))
  top = Math.max(padding, Math.min(top, vh - cr.height - padding))

  styleObj.value = {
    position: 'fixed',
    top: `${Math.round(top)}px`,
    left: `${Math.round(left)}px`
  }
}

function scheduleCompute() {
  // Run after DOM shows the tooltip
  nextTick(() => {
    requestAnimationFrame(() => computePosition())
  })
}

watch(() => ctx?.isOpen.value, (open) => {
  if (open) scheduleCompute()
})

watch(() => [props.side, props.offset], () => {
  if (ctx?.isOpen.value) scheduleCompute()
})

function onWinChange() {
  if (ctx?.isOpen.value) computePosition()
}

onMounted(() => {
  window.addEventListener('resize', onWinChange)
  window.addEventListener('scroll', onWinChange, true)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', onWinChange)
  window.removeEventListener('scroll', onWinChange, true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "tt-fade" }, {
      default: _withCtx(() => [
        (_unref(ctx))
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _unref(ctx)?.id,
              role: "tooltip",
              class: _normalizeClass(classes.value),
              style: _normalizeStyle(styleObj.value),
              ref_key: "el",
              ref: el
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 14, _hoisted_1)), [
              [_vShow, _unref(ctx)?.isOpen.value]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})